/* The Go Getter card deck: flip, flip all, deal a random card */
(function () {
    const deck = document.querySelector('[data-gg-deck]');
    if (!deck) return;

    const cards = Array.prototype.slice.call(deck.querySelectorAll('[data-gg-card]'));
    if (!cards.length) return;

    deck.classList.add('gg-js');

    // Show the buttons that only work with JavaScript.
    document.querySelectorAll('[data-gg-deal], [data-gg-flip-all], .gg-front [data-gg-flip]').forEach(function (el) {
        el.hidden = false;
    });

    // Number the cards: the oldest edition is No. 01.
    const total = cards.length;
    cards.forEach(function (card, i) {
        const no = card.querySelector('[data-gg-no]');
        if (no) no.textContent = 'No. ' + String(total - i).padStart(2, '0');
    });

    const count = document.querySelector('[data-gg-count]');
    if (count) {
        count.textContent = 'Tap a card to flip it. ' + total + (total === 1 ? ' edition so far.' : ' editions so far.');
    }

    function setFlipped(card, flipped) {
        card.classList.toggle('is-flipped', flipped);
        const back = card.querySelector('.gg-back');
        const front = card.querySelector('.gg-front');
        // Keep keyboard focus on the visible side only.
        if (back) back.inert = flipped;
        if (front) front.inert = !flipped;
    }

    cards.forEach(function (card) {
        setFlipped(card, false);
        card.querySelectorAll('[data-gg-flip]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const flipped = !card.classList.contains('is-flipped');
                setFlipped(card, flipped);
                const target = card.querySelector(flipped ? '.gg-read' : '.gg-back-btn');
                if (target) target.focus({preventScroll: true});
            });
        });
    });

    const flipAll = document.querySelector('[data-gg-flip-all]');
    if (flipAll) {
        flipAll.addEventListener('click', function () {
            const allUp = cards.every(function (c) { return c.classList.contains('is-flipped'); });
            cards.forEach(function (c) { setFlipped(c, !allUp); });
            flipAll.textContent = allUp ? 'Flip the whole deck' : 'Turn them all over';
        });
    }

    let lastDealt = null;
    function deal() {
        let pool = cards.filter(function (c) { return c !== lastDealt; });
        if (!pool.length) pool = cards;
        const card = pool[Math.floor(Math.random() * pool.length)];
        lastDealt = card;
        setFlipped(card, true);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        card.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
        const read = card.querySelector('.gg-read');
        if (read) read.focus({preventScroll: true});
    }

    document.querySelectorAll('[data-gg-deal]').forEach(function (btn) {
        btn.addEventListener('click', deal);
    });

    // Arriving from "Pull another card" on an edition page.
    if (new URLSearchParams(window.location.search).has('deal')) {
        window.setTimeout(deal, 300);
    }
})();
